import { render, staticRenderFns } from "./FreightList.vue?vue&type=template&id=6d29c5a4&scoped=true"
import script from "./FreightList.vue?vue&type=script&lang=js"
export * from "./FreightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29c5a4",
  null
  
)

export default component.exports